import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ButtonProps } from '@mui/material';
import { usePalette } from 'src/hooks';
import { Button } from '../atoms';

interface Props extends ButtonProps {
  children: ReactNode;
  loading?: boolean;
}

const StyledRoundedButton = styled(Button)(
  ({ theme }) => `
  border-radius: 20;
  color: ${theme.palette.text.primary};

  &:disabled {
    background-color: ${theme.palette.primary.main};
  }
`
);

export const RoundedButton = ({ children, ...props }: Props) => {
  const { primary } = usePalette();

  return (
    <StyledRoundedButton
      staticWidth='12rem'
      sx={{ textTransform: 'uppercase', borderRadius: 10, backgroundColor: primary.main, p: '0.7rem 0.6rem' }}
      {...props}
    >
      {children}
    </StyledRoundedButton>
  );
};
